import { getIn, useFormikContext } from 'formik';

export const useFormikField = (name: string) => {
  const { errors, touched, values, setFieldValue, validateField } = useFormikContext<any>();
  // Access nested values using getIn
  const value = getIn(values, name);
  const error = getIn(errors, name);
  const isTouched = getIn(touched, name);
  const hasError = error && isTouched;

  // Custom setter to update nested value
  const setValue = (newValue: any) => setFieldValue(name, newValue);

  const validate = () => validateField(name);

  return {
    value,
    error: hasError ? `${error}` : undefined,
    hasError,
    setValue,
    validate,
  };
};
